import {clearCurrentUser, logoutUser} from "../../actions/authActions";
import {useDispatch} from "react-redux";

export default function LogoutButton({classList}) {
  const dispatch = useDispatch();

  const onLogoutClick = (e) => {
    e.preventDefault();
    dispatch(clearCurrentUser());
    dispatch(logoutUser());
  };

  return (
    <button className={classList} onClick={onLogoutClick}>
      Abmelden
    </button>
  )
}
